import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldLowerHigherValidator } from '@shared/validators/cross-field-lower-higher-validator';
import { diseasesValidator } from '@shared/validators/diseases-validator';

export const venisafeMaternaValidationSet: ValidationPair = {
  children: {
    venisafe: {
      children: {
        patientHistory: {
          children: {
            cardiovascularConditions: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator()],
            },
            cardiovascularConditionsInFamily: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator(true)],
            },
          },
        },
      },
    },
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            numberOfPregnancies: {
              validators: [Validators.required, Validators.min(0)],
            },
            numberOfBirths: {
              validators: [Validators.required, Validators.min(0)],
            },
          },
          validators: [
            crossFieldLowerHigherValidator(
              'numberOfBirths',
              'numberOfPregnancies',
              true
            ),
          ],
        },
      },
    },
  },
};
